import React from 'react'

const WhatsappIcon = (props) => (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.6349 8.21459C10.4667 7.84164 10.2895 7.83415 10.1294 7.82766C9.99846 7.82204 9.8486 7.82233 9.69902 7.82233C9.5493 7.82233 9.30593 7.87853 9.10014 8.10262C8.8942 8.3267 8.31382 8.86855 8.31382 9.97054C8.31382 11.0727 9.11878 12.1375 9.23107 12.2871C9.34336 12.4365 10.7849 14.7702 13.0679 15.668C14.9652 16.4142 15.3513 16.2657 15.7631 16.2284C16.175 16.1911 17.092 15.6866 17.2791 15.1636C17.4664 14.6406 17.4664 14.1924 17.4102 14.0986C17.354 14.0054 17.2043 13.9493 16.9797 13.8374C16.7551 13.7254 15.6508 13.1834 15.4449 13.1088C15.239 13.034 15.0892 12.9968 14.9395 13.221C14.7897 13.445 14.3596 13.9493 14.2285 14.0986C14.0974 14.2484 13.9663 14.2671 13.7418 14.155C13.5172 14.0427 12.7937 13.8064 11.9356 13.0433C11.2679 12.4498 10.817 11.7165 10.6859 11.4923C10.555 11.2684 10.6838 11.1577 10.7846 11.0353C10.9663 10.815 11.2711 10.4189 11.3459 10.2696C11.4208 10.12 11.3834 9.98927 11.3273 9.87716C11.2711 9.76518 10.8345 8.65758 10.6349 8.21459Z"
        fill="#0D1536"
        fillOpacity="0.65"
      />
      <path
        d="M19.3354 5.59715C17.5842 3.85865 15.2493 2.89282 12.7615 2.89282C7.61905 2.89282 3.44951 7.0321 3.44951 12.1372C3.44951 13.7377 3.86647 15.3107 4.65868 16.7042L3.31053 21.5886L8.35566 20.2778C9.70381 20.9953 11.2187 21.3816 12.7615 21.3816C17.89 21.3816 22.0734 17.2423 22.0734 12.1372C22.0595 9.66744 21.1005 7.34944 19.3354 5.59715ZM6.63226 16.4283L6.42378 16.0971C5.67326 14.8967 5.27021 13.5308 5.27021 12.1372C5.27021 8.03932 8.63363 4.7141 12.7615 4.7141C14.7628 4.7141 16.6391 5.48677 18.0568 6.89412C19.4744 8.30148 20.2527 10.1642 20.2527 12.151C20.2527 16.2489 16.8893 19.5741 12.7754 19.5741C11.4272 19.5741 10.1069 19.2154 8.96719 18.5393L8.63363 18.3461L5.90954 19.036L6.63226 16.4283Z"
        fill="#0D1536"
        fillOpacity="0.65"
      />
    </svg>
  )


export default WhatsappIcon
